import { createSelector, Selector } from '@reduxjs/toolkit';
import { storeSelector } from '../StoreSelector';
import { StoreState } from '../StoreState';

const createdMoonLists = createSelector(storeSelector, (state) => state.user.moonLists);
const favoriteMoonLists = createSelector(storeSelector, (state) => state.user.currentUser?.favoriteMoonLists ?? []);
const isFavoriteMoonList = (id: string): Selector<StoreState, boolean> =>
  createSelector(storeSelector, (state) =>
    (state.user.currentUser?.favoriteMoonLists ?? []).some((moonList) => moonList.id === id)
  );

export default {
  createdMoonLists,
  favoriteMoonLists,
  isFavoriteMoonList
};
